// UserLevelBadge.js
'use strict';
import { connect } from 'react-redux';
import { push } from 'redux-first-history';
import getMeData from '../selector/getMeData.js';
import getUserData from '../selector/getUserData.js';
import UserLevelBadge from '../component/UserLevelBadge.jsx';
import getCurrentUnixTimestamp from '../resource/getCurrentUnixTimestamp.js';
import getCurrentUserLevel from '../resource/getCurrentUserLevel.js';
import getTimestampOffset, {
  Accuracy,
} from '../selector/getTimestampOffset.js';

const mapStateToProps = (state, { level: staticLevel, userId }) => {
  let level = undefined;
  if (staticLevel) {
    level = staticLevel;
  } else if (userId) {
    const meId = getMeData(state, 'id');
    const levelData =
      userId === meId
        ? getMeData(state, 'level')
        : getUserData(state, userId, 'level');
    const timestampOffsetSeconds = getTimestampOffset(state, Accuracy.SECOND);
    const now = getCurrentUnixTimestamp({
      offsetSeconds: timestampOffsetSeconds,
    });
    level = getCurrentUserLevel({
      levelData,
      unixTimestamp: now,
    });
  }
  return {
    level,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    directToInfomation: () => dispatch(push('/settings/vvip')),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserLevelBadge);
